/* Produktseite: Rabatt-Badge "Save …" -> "Spare …"
   Funktioniert auch, wenn der Badge erst nachträglich (App / Variantenwechsel) eingefügt wird. */
(function () {
  var PATTERN = /\bSave\b/;
  var PATTERN_ALL = /\bSave\b/g;

  function fix(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue;
      if (value && PATTERN.test(value)) {
        node.nodeValue = value.replace(PATTERN_ALL, 'Spare');
      }
    }
  }

  function init() {
    var roots = document.querySelectorAll('section[id^="MainProduct-"]');
    roots.forEach(function (root) {
      fix(root);
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          fix(root);
        });
      }).observe(root, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
